// Token CSRF para las llamadas AJAX (meta del layout) y opciones de la pantalla: la vista las deja en
// <script type="application/json" id="pageOptions"> (page_options()) y el JS las lee como window.options.
// Igual que en la rama del módulo de citas (resources/js/core/components.js).
window.csrfToken = () =>
  document.querySelector('meta[name="csrf-token"], meta[name="_token"]')?.getAttribute('content') || ''

if (!Object.prototype.hasOwnProperty.call(window, 'options')) {
  Object.defineProperty(window, 'options', {
    configurable: true,
    get() {
      const el = document.getElementById('pageOptions')
      const value = el ? JSON.parse(el.textContent) : undefined
      if (el) Object.defineProperty(window, 'options', { value, writable: true, configurable: true })
      return value
    }
  })
}

window.showCustomToast = function (message, type = 'success') {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    icon: type
  })

  Toast.fire({
    title: message
  })
}

window.deleteItem = function (deleteRoute, redirectRoute) {
  Swal.fire({
    title: 'Está seguro?',
    text: 'Esta acción es irreversible!',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Sí, eliminar!',
    cancelButtonText: 'No'
  }).then(result => {
    if (result.isConfirmed) {
      axios
        .delete(deleteRoute)
        .then(function (response) {
          Swal.fire('Eliminado!', 'Ha sido eliminado correctamente.', 'success').then(() => {
            window.location.href = redirectRoute
          })
        })
        .catch(function (error) {
          let errorMessage = 'Algo ha ido mal. Por favor, inténtelo de nuevo'

          if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message
          }

          Swal.fire('Error!', errorMessage, 'error')
          console.error(error)
        })
    }
  })
}

window.toggleActive = function (button) {
  const url = button.getAttribute('data-url')
  const redirectUrl = button.getAttribute('data-redirect')
  const isActive = button.getAttribute('data-active') === '1'

  const action = isActive ? 'desactivar' : 'activar'
  const actionCapitalized = isActive ? 'Desactivar' : 'Activar'
  const confirmButtonColor = isActive ? '#d33' : '#28a745'

  Swal.fire({
    title: `¿${actionCapitalized}?`,
    text: `¿Desea ${action} este registro?`,
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: confirmButtonColor,
    cancelButtonColor: '#6c757d',
    confirmButtonText: `Sí, ${action}!`,
    cancelButtonText: 'Cancelar'
  }).then(result => {
    if (result.isConfirmed) {
      axios
        .post(url)
        .then(function (response) {
          Swal.fire('Actualizado!', response.data.message, 'success').then(() => {
            window.location.href = redirectUrl
          })
        })
        .catch(function (error) {
          let errorMessage = 'Algo ha ido mal. Por favor, inténtelo de nuevo'

          if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message
          }

          Swal.fire('Error!', errorMessage, 'error')
          console.error(error)
        })
    }
  })
}

window.showLoader = function () {
  $('#loader-overlay').show()
}

window.hideLoader = function () {
  $('#loader-overlay').hide()
}

window.getCurrentPage = function () {
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get('page') || 1
}

function validateTwoDigitDecimalNumber(event) {
  const regex = /^[+-]?\d*\.?\d{0,2}$/g
  const specialKeys = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete']

  if (specialKeys.indexOf(event.key) !== -1) {
    return
  }

  const current = event.target.value
  const position = event.target.selectionStart
  const next = [current.slice(0, position), event.key === 'Decimal' ? '.' : event.key, current.slice(position)].join('')

  if (next && !String(next).match(regex)) {
    event.preventDefault()
  }
}

// Accesos rápidos: ?nuevo=1 abre el modal de "nuevo registro" del listado y se quita de la URL.
;(function () {
  const params = new URLSearchParams(location.search)
  if (!params.has('nuevo')) return
  params.delete('nuevo')
  history.replaceState(null, '', location.pathname + (params.toString() ? '?' + params : '') + location.hash)
  $(window).on('load', () =>
    setTimeout(() => {
      const trigger = [...document.querySelectorAll('[data-bs-target="#onFormModal"]')].find(
        el => !el.hasAttribute('data-bs-id-item') && el.offsetParent !== null
      )
      trigger?.click()
    }, 150)
  )
})()

// Select2 4.0 con jQuery 3.6 no pone el foco en el buscador al abrir la lista: se pone aquí para todos los select2.
$(document).on('select2:open', function (e) {
  window.setTimeout(function () {
    const instance = $(e.target).data('select2')
    const field = instance && instance.$dropdown.find('.select2-search__field')[0]
    if (field) field.focus()
  }, 0)
})

// Ícono de calendario junto a una fecha (.date-picker-toggle dentro del .input-group): al hacerle click abre el
// flatpickr del input del grupo (con altInput el flatpickr vive en el input original, que queda oculto).
document.addEventListener('click', function (e) {
  const toggle = e.target.closest('.date-picker-toggle')
  if (!toggle) return
  const group = toggle.closest('.input-group')
  const input = group && Array.from(group.querySelectorAll('input')).find(el => el._flatpickr)
  if (input) input._flatpickr.open()
})
